module.exports = __webpack_public_path__ + "img/bg-mision-2-19.1ccf26da.jpg";